export default {"src":"/_next/static/media/product-diamond.a037d508.svg","height":360,"width":360};